<template>
   <main class="fix">
      <!-- breadcrumb-area -->
      <section class="breadcrumb__area breadcrumb__bg">
         <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100"
            :style="{ backgroundImage: `url('assets/img/banner/banner1.png')` }"></div>
         <div class="container">
            <div class="row">
               <div class="col-lg-12">
                  <div class="breadcrumb__content">
                     <h2 class="title">Destinasi Yang Dikelola Masyarakat</h2>
                     <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                           <li class="breadcrumb-item"><a href="javascript:void(0);"
                                 @click="$router.push('/')">Beranda</a></li>
                           <li class="breadcrumb-item active" aria-current="page">Destinasi Yang Dikelola Masyarakat</li>
                        </ol>
                     </nav>
                  </div>
               </div>
            </div>
         </div>
         <div class="breadcrumb__shape">
            <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
            <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
            <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
            <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
            <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
         </div>
      </section>
      <section class="blog_area mt-5">
         <div class="container pb-40">
            <div class="row justify-content-center">
               <div class="blog-post-wrap">
                  <div class="sidebar__widget sidebar__widget-two">
                     <div class="sidebar__search">
                        <form action="#">
                           <input type="text" v-model="cari_value" @keyup="cari_data()" placeholder="Cari Data" />
                           <button type="button" style="cursor: default;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                 <path
                                    d="M19.0002 19.0002L14.6572 14.6572M14.6572 14.6572C15.4001 13.9143 15.9894 13.0324 16.3914 12.0618C16.7935 11.0911 17.0004 10.0508 17.0004 9.00021C17.0004 7.9496 16.7935 6.90929 16.3914 5.93866C15.9894 4.96803 15.4001 4.08609 14.6572 3.34321C13.9143 2.60032 13.0324 2.01103 12.0618 1.60898C11.0911 1.20693 10.0508 1 9.00021 1C7.9496 1 6.90929 1.20693 5.93866 1.60898C4.96803 2.01103 4.08609 2.60032 3.34321 3.34321C1.84288 4.84354 1 6.87842 1 9.00021C1 11.122 1.84288 13.1569 3.34321 14.6572C4.84354 16.1575 6.87842 17.0004 9.00021 17.0004C11.122 17.0004 13.1569 16.1575 14.6572 14.6572Z"
                                    stroke="currentcolor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                              </svg>
                           </button>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div class="container">
            <div class="row">
               <div class="row justify-content-center">
                  <div class="col-xl-4 col-lg-6 col-md-10" v-for="data in list_data" :key="data.id">
                     <div class="blog-post-item shine-animate-item">
                        <div class="blog-post-thumb">
                           <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="selectData(data)"><img :src="file_path + data.foto" alt="Apexa" /></a>
                        </div>
                        <div class="blog-post-content">
                           <h2 class="title"><a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="selectData(data)">{{ data.judul }}</a></h2>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="pagination-wrap mt-40 mb-5">
                  <nav aria-label="Page navigation example">
                     <ul class="pagination list-wrap">
                        <!-- Prev -->
                        <li class="page-item" :class="{ disabled: page_first === 1 }"><a class="page-link"
                              href="javascript:void(0);" @click="btn_prev"><i class="fas fa-angle-double-left"></i></a>
                        </li>

                        <!-- Loop halaman -->
                        <li v-for="page in pagesToShow" :key="'page_' + page" class="page-item"
                           :class="{ active: page === page_first, disabled: page === '...' }">
                           <a v-if="page !== '...'" class="page-link" href="javascript:void(0);"
                              @click="goToPage(page)">
                              {{ page }}
                           </a>
                           <span v-else class="page-link">...</span>
                        </li>

                        <!-- Next -->
                        <li class="page-item" :class="{ disabled: page_first === page_last }"><a class="page-link"
                              href="javascript:void(0);" @click="btn_next"><i class="fas fa-angle-double-right"></i></a>
                        </li>
                     </ul>
                  </nav>
               </div>
            </div>
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-hidden="true">
               <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                     <div class="modal-header">
                        <h5 class="modal-title">Lampiran</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                     </div>
                     <div class="modal-body">
                        <div class="text-center">
                           <img class="img-responsive" :src="file_path + form.foto" alt="clients">
                        </div>
                        <hr>
                        <h5><b>{{ form.judul }}</b></h5>
                        <hr>
                        <p v-html="form.isi"></p>
                     </div>
                     <div class="modal-footer">
                        <button type="button" class="blog__post-tag-two" data-bs-dismiss="modal">Keluar</button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="project__shape-wrap-two">
            <img class="dark-opacity" src="assets/img/project/h2_project_shape.png" alt="Apexa" data-aos="fade-left"
               data-aos-delay="400" />
         </div>
      </section>
   </main>
</template>

<script>
import UMUM from '../../library/umum'

export default {

   data() {
      return {
         data_load: false,
         form: {
            id: '',
            judul: '',
            deskripsi: '',
            file: '',
            unit_kerja: '',
            status: '',
            createBy: '',
            createAt: '',
         },
         id: '',
         cek_load_data: true,
         file_old: "",
         file_path: this.$store.state.url.URL_APP + "uploads/",
         UMUM: UMUM,

         list_data: [],
         page_first: 1,
         page_last: 0,
         max_visible: 5,
         cari_value: "",
         kat_wisata: "Destinasi yang Dikelola Masyarakat"
      }
   },
   methods: {
      getView: function () {
         fetch(this.$store.state.url.URL_PARIWISATA + "view", {
            method: "POST",
            headers: {
               "content-type": "application/json",
            },
            body: JSON.stringify({
               data_ke: this.page_first,
               cari_value: this.cari_value,
               kat_wisata: this.kat_wisata,
            })
         })
            .then(res => res.json())
            .then(res_data => {
               this.list_data = res_data.data;
               this.page_last = res_data.jml_data;
               // console.log(res_data);
            });
      },

      selectData: function (data) {
         // console.log(data);
         this.form = {
            id: data.id,
            judul: data.judul,
            isi: data.isi,
            foto: data.foto,
            unit_kerja: data.unit_kerja,
            status: data.status,
            createBy: data.createBy,
            createAt: data.createAt,
         };
      },
      ke_alamat: function (data) {
         window.open(data);
      },

      mdl_exit: function () {
         this.judul = "";
         this.uraian = "";
         this.file = "";
         this.file_old = "";
      },

      // ================== PAGINASI ====================
      alertku: function (type, title) {
         this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
         });
      },

      btn_prev: function () {
         this.cek_load_data = true;
         if (this.page_first > 1) {
            this.page_first--
         } else {
            this.page_first = 1;
         }
         this.getView();
      },

      btn_next: function () {

         if (this.page_first >= this.page_last) {
            this.page_first == this.page_last
         } else {
            this.page_first++;
         }
         this.getView();
      },

      goToPage(page) {
         if (page === '...') return;
         this.page_first = page;
         this.getView();
      },

      cari_data: function () {

         this.page_first = 1;
         this.getView();
      },
      onFileSelected: function (event) {
         this.form.file = event.target.files[0];
      },
      convert_tgl: function (dateString) {
         var date = new Date(dateString);
         return date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear();
      },
      // ================== PAGINASI ====================

      // ================== MODAL ====================
      buka_modal: function (modalku) {
         var modal = document.getElementById(modalku);
         modal.style.display = "block";
      },

      tutup_modal: function (modalku) {
         var modal = document.getElementById(modalku);
         modal.style.display = "none";
      },

      // ================== MODAL ====================
   },
   // =============================================================== METHODS =========================================================================

   computed: {
      pagesToShow() {
         const pages = [];
         const total = this.page_last;
         const current = this.page_first;
         const max = this.max_visible;

         if (total <= max) {
            for (let i = 1; i <= total; i++) pages.push(i);
         } else {
            pages.push(1);

            if (current > 3) pages.push("...");

            const start = Math.max(2, current - 1);
            const end = Math.min(total - 1, current + 1);

            for (let i = start; i <= end; i++) pages.push(i);

            if (current < total - 2) pages.push("...");

            pages.push(total);
         }

         return pages;
      },
   },

   mounted() {

      this.getView();

   }
};
</script>

<style>
.image-box img {
   width: 100% !important;
   height: 100% !important;
   object-fit: contain !important;
   background-color: #f0f0f0 !important;
   /* biar backgroundnya nggak putih */
}
</style>